const Index = () => import(/* webpackChunkName: "web" */ './Index');
const Edit = () => import(/* webpackChunkName: "web" */ './Edit');
const View = () => import(/* webpackChunkName: "web" */ './View');

export default {
  routes: [
    {
      path: '/web/section',
      name: 'web_section',
      component: Index
    }, {
      path: '/web/section/edit/:dbid?',
      name: 'web_section_edit',
      component: Edit
    }, {
      path: '/web/section/view/:dbid',
      name: 'web_section_view',
      component: View
    }
  ]
}
